import { SearchOutlined } from '@ant-design/icons';
import { Trans, useTranslation } from 'react-i18next';
import { AntdEmpty, AntdTypography } from '@ui/components';
import { ContactSupport } from './ContactSupport';

const { Text } = AntdTypography;

type EmptyStateProps = {
  enabledAnalytics: boolean;
  queryEnabled: boolean;
  searchString?: string;
};

export const EmptyState = ({
  enabledAnalytics,
  queryEnabled,
  searchString = '',
}: EmptyStateProps) => {
  const { t } = useTranslation();

  if (!queryEnabled) {
    return (
      <AntdEmpty
        className="py-12"
        description={t('sign_up_v2_page.disease_form.disease_search_v2.empty_filters_description')}
      />
    );
  }

  return (
    <div className="px-4 md:px-6 py-6 flex flex-col gap-4">
      <div className="relative overflow-hidden rounded-2xl border border-base-200 bg-white">
        <div className="absolute inset-0 bg-gradient-to-br from-base-100 via-transparent to-base-200/30" />

        <div className="relative p-5">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-base-200 flex items-center justify-center">
              <SearchOutlined className="text-xl text-base-600" />
            </div>
            <div className="flex flex-col gap-2">
              <Text className="text-base font-semibold text-base-800">
                <Trans
                  t={t}
                  i18nKey="sign_up_v2_page.disease_form.disease_search_v2.not_found.title"
                  values={{ searchTerm: searchString }}
                  components={{
                    b: <span className="font-bold text-primary-600" />,
                  }}
                />
              </Text>
              <Text className="text-sm text-base-600">
                <Trans
                  t={t}
                  i18nKey="sign_up_v2_page.disease_form.disease_search_v2.not_found.description"
                  components={{
                    br: <br />,
                  }}
                />
              </Text>
              <ul className="list-none p-0 mt-2 space-y-1.5">
                {(
                  t('sign_up_v2_page.disease_form.disease_search_v2.not_found.suggestions', {
                    returnObjects: true,
                  }) as string[]
                ).map((suggestion) => (
                  <li key={suggestion} className="flex items-start gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500 mt-2 flex-shrink-0" />
                    <Text className="text-sm text-base-700">{suggestion}</Text>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <ContactSupport
        key={searchString}
        enabledAnalytics={enabledAnalytics}
        searchString={searchString}
        title={t('sign_up_v2_page.disease_form.disease_search_v2.contact.title_not_found')}
      />
    </div>
  );
};
